import Column from 'canvas-core-react/lib/Column';
import TextHeadline from 'canvas-core-react/lib/TextHeadline';
import React from 'react';
// ICONS
import { ReactComponent as Icon1 } from '../icons/icon_backbanner_1.svg';
// STYLES
import './BlackBannerStyle.scss';

const BlackBanner = () => {
	const title = 'Invierte en Depósitos a Plazo y hazte cliente Scotia';

	return (
		<div className="Blackbanner">
			<div className="Blackbanner_container">
				<div className="Blackbanner_content">
					<Column lg={12}>
						<div className='blackbanner_v1'>
							<Column lg={6} className='blackbanner_v1_text_container'>
								<TextHeadline className='blackbanner_v1_title' component='div'>{title}</TextHeadline>
							</Column>
							<Column lg={6} className='blackbanner_v1_icon_container'>
								<Icon1 />
							</Column>
						</div>
					</Column>
				</div>
			</div>
		</div>
	)
}

export default BlackBanner;